<template>
  <div class="inspection-main">
    <div class="inspection-wrap">
      <header class="header">
        <div class="header-1"></div>

        <div class="header-2">
          <div class="logo">
            <img src="https://renhe-platform-pre.oss-cn-shanghai.aliyuncs.com/2025-04-28/1745819464041_header-title-bj.png" />
          </div>
        </div>
      </header>

      <div class="content">
        <ul class="tab">
          <li v-for="(item, index) of tab" :class="{ 'is-active': index == tabIndex }" @click="tabClick(index)" :key="index">{{ item.label }}</li>
        </ul>

        <ul class="con">
          <li class="con1" v-show="tabIndex == 0">
            <div class="qr-code">
              <img src="https://renhe-platform-pre.oss-cn-shanghai.aliyuncs.com/2025-04-28/1745821277173_qrcode-222.png" />
            </div>

            <div class="tip">
              <p>温馨提示</p>
              <p>请下载并使用电子营业执照APP、微信或支付宝小程序扫一扫登录</p>
              <p><span>点此处详细了解</span>，企业为办事人授权时，授权事项请选择“电子政务-市场监管-企业年报”；技术支持电话：010-<br />82691819</p>
            </div>
          </li>

          <li class="con2" v-show="tabIndex == 1">
            <div class="con2-form">
              <el-form ref="formRef" :model="formData" :rules="formRules" @submit.prevent label-width="185" autocomplete="new-password">
                <el-form-item label="统一社会信用代码/注册号" prop="regCode">
                  <el-input v-model.trim="formData.regCode" @blur="regCodeBlur" autocomplete="new-password" />
                </el-form-item>

                <el-form-item label="工商联络员身份证号码" prop="cardId">
                  <el-input v-model.trim="formData.cardId" maxlength="30" autocomplete="new-password" />
                </el-form-item>

                <el-form-item label="密码" prop="password">
                  <el-input v-model.trim="formData.password" maxlength="20" type="password" show-password autocomplete="new-password" />
                </el-form-item>

                <el-form-item label="企业（个体、农专）名称" prop="companyName">
                  <el-input v-model.trim="formData.companyName" autocomplete="new-password" />
                </el-form-item>

                <el-form-item label="工商联络员姓名" prop="userName">
                  <el-input v-model.trim="formData.userName" autocomplete="new-password" />
                </el-form-item>

                <el-form-item label="工商联络员手机号" prop="userMobile">
                  <el-input v-model.trim="formData.userMobile" maxlength="11" :formatter="(value) => value.replace(/[^\d]/g, '')" autocomplete="new-password" />
                </el-form-item>

                <el-form-item label="手机验证码" prop="mobileCode">
                  <el-row :gutter="10">
                    <el-col :span="14">
                      <el-input v-model.trim="formData.mobileCode" maxlength="6" autocomplete="new-password" />
                    </el-col>
                    <el-col :span="10">
                      <div class="el-col-mobileCode">
                        <el-button type="primary">获取验证码</el-button>
                      </div>
                    </el-col>
                  </el-row>
                </el-form-item>

                <el-form-item label="验证码" prop="verifyCode">
                  <el-row :gutter="10">
                    <el-col :span="14">
                      <el-input v-model.trim="formData.verifyCode" maxlength="5" autocomplete="new-password" />
                    </el-col>
                    <el-col :span="10">
                      <div class="el-col-verifyCode">
                        <img src="https://renhe-platform-pre.oss-cn-shanghai.aliyuncs.com/2025-04-28/1745828526260_checkCodeServlet.jpg" />
                        <el-button type="primary" link>换一张</el-button>
                      </div>
                    </el-col>
                  </el-row>
                </el-form-item>

                <el-form-item class="el-form-item-f" label-width="0">
                  <el-button type="primary" @click="formSubmit">登录</el-button>
                  <el-button type="primary" @click="formReset">重置</el-button>
                  <el-button type="primary" @click="gotoPage('area')">返回</el-button>
                </el-form-item>
              </el-form>
            </div>
          </li>
        </ul>
      </div>

      <div class="content-tip">
        <p v-show="tabIndex == 1">说明：在首次【企业公示信息填报】之前，请先 <span @click="gotoPage('register')">【企业联络员注册】</span>，若注册信息发生变化请<span>【企业联络员变更】</span>！</p>
      </div>
    </div>

    <div class="inspection-footer">
      <div class="con">
        <div class="con1">
          <img src="https://renhe-platform-pre.oss-cn-shanghai.aliyuncs.com/2025-04-28/1745822382403_shibie.png" />
          <img src="https://renhe-platform-pre.oss-cn-shanghai.aliyuncs.com/2025-04-28/1745822412493_jiucuo.png" />
        </div>

        <div class="con2">
          <div class="link"><span>站点地图</span>|<span>关于我们</span>|<span>建议意见</span>|<span>法律声明</span>|<span>联系我们</span></div>
          <p>主办：北京市市场监督管理局 承办：北京市市场监督管理局 地址：北京市通州区留庄路6号院1号楼 邮政编码：101117</p>
          <div class="text">
            <p>政府网站标识码：1100000065</p>
            <p>京公网安备 11040102700026</p>
            <p>京ICP备19008898号-3</p>
          </div>
          <p>
            业务咨询与技术支持联系方式， 服务时间：周一至周日9点-17点 （国家法定节假日除外）<br />
            扫描右侧二维码，关注微信公众账号“企业年报系统技术支持”，获取在线支持
          </p>
          <p class="tip">温馨提示：请使用IE8.0以上浏览器、360浏览器、firefox浏览器</p>
        </div>

        <ul class="con3">
          <li>
            <img src="https://renhe-platform-pre.oss-cn-shanghai.aliyuncs.com/2025-04-28/1745822787974_gfwx.jpg" />
            <p>官方微信</p>
          </li>

          <li>
            <img src="https://renhe-platform-pre.oss-cn-shanghai.aliyuncs.com/2025-04-28/1745822852481_gfwb.jpg" />
            <p>官方微博</p>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ElMessageBox } from "element-plus";
import { cloneDeep } from "lodash";
import { $emit, $on } from "vue-happy-bus";

const props = defineProps({
  inspectionData: {
    required: true,
    type: Object,
  },
});

const checkRule = inject("checkRule");

const tab = ref([
  { label: "电子营业执照登录", value: 1 },
  { label: "工商联络员登录", value: 2 },
  { label: "个体工商户经营者登录", value: 3 },
  { label: "一证通证书登录", value: 4 },
  { label: "统一认证登录", value: 5 },
]);

const tabIndex = ref(0);

const tabClick = (index) => {
  if (tabIndex.value != index && index <= 1) {
    tabIndex.value = index;
  }
};

const formData = ref({});

const formRules = {
  regCode: [
    {
      required: true,
      message: "统一社会信用代码/注册号不能为空",
      trigger: ["blur", "change"],
    },
  ],
  cardId: [
    {
      required: true,
      message: "工商联络员身份证号码不能为空",
      trigger: ["blur", "change"],
    },
  ],
  password: [
    {
      required: true,
      message: "密码不能为空",
      trigger: ["blur", "change"],
    },
  ],
  companyName: [
    {
      required: true,
      message: "企业（个体、农专）名称不能为空",
      trigger: ["blur", "change"],
    },
  ],
  userName: [
    {
      required: true,
      message: "工商联络员姓名不能为空",
      trigger: ["blur", "change"],
    },
  ],
  userMobile: [
    {
      required: true,
      message: "工商联络员手机号不能为空",
      trigger: ["blur", "change"],
    },
  ],
  mobileCode: [
    {
      required: true,
      message: "手机验证码不能为空",
      trigger: ["blur", "change"],
    },
  ],
  verifyCode: [
    {
      required: true,
      message: "验证码不能为空",
      trigger: ["blur", "change"],
    },
  ],
};

const formRef = ref();
const formSubmit = async () => {
  const regCodeBlurRes = await regCodeBlur();

  formRef.value.validate((isValid) => {
    if (regCodeBlurRes && isValid) {
      const inspectionDataClone = cloneDeep(props.inspectionData);
      inspectionDataClone.formDataLogin = formData.value;
      $emit("inspectionSubmit", inspectionDataClone);
      gotoPage("center");
    }
  });
};

const formReset = () => {
  formRef.value.resetFields();
};

const regCodeBlur = async () => {
  try {
    const isValid = await formRef.value.validateField("regCode");
    const { formDataRegister } = props.inspectionData;

    if (isValid) {
      if (formDataRegister.regCode && formDataRegister.regCode == formData.value.regCode) {
        const { companyName } = checkRule.value;
        const { userName, userMobile } = formDataRegister;

        Object.assign(formData.value, {
          companyName,
          userName,
          userMobile,
        });
        return true;
      } else {
        const message = "提示：用户未注册，请点击【企业联络员注册】进行注册！";
        // ElMessageBox.alert(message);
        alert(message);
      }
    }
  } catch (e) {}
};

const emits = defineEmits(["gotoPage"]);

const gotoPage = (page) => {
  emits("gotoPage", page);
};
</script>

<style scoped lang="scss">
.inspection-main {
  background-color: #f7f7f7;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-height: 100%;

  .inspection-wrap {
    overflow: hidden;
    flex-shrink: 0;

    .header {
      padding: 8px;

      .header-1 {
        width: 1300px;
        height: 80px;
        margin: auto;
        background: url(https://renhe-platform-pre.oss-cn-shanghai.aliyuncs.com/2025-04-28/1745818717452_header-title-bjscj.png) 0% center no-repeat;
        background-position: 0% center;
      }

      .header-2 {
        border-top: 11px solid rgb(189, 26, 45);
        height: 109px;
        background: #ffffff url(https://renhe-platform-pre.oss-cn-shanghai.aliyuncs.com/2025-04-28/1745818808900_bj.png) no-repeat right top;

        .logo {
          width: 1100px;
          margin: 0 auto;
          height: 100%;
          display: flex;
          align-items: center;
        }
      }
    }

    .content {
      width: 937px;
      margin: 40px auto;
      background-color: #ffffff;

      .tab {
        font-size: 18px;
        height: 47px;
        background-color: #ab812d;
        border-top-right-radius: 3px;
        border-top-left-radius: 3px;
        color: #ffffff;
        display: flex;
        box-sizing: border-box;
        padding-top: 10px;
        padding-left: 12px;

        li {
          display: flex;
          justify-content: center;
          align-items: center;
          cursor: pointer;
          padding: 0 5px;
          border-top-right-radius: 3px;
          border-top-left-radius: 3px;

          &:not(:nth-last-of-type(1)) {
            margin-right: 17px;
          }

          &.is-active,
          &:hover {
            background: #ffffff;
            color: #ab812d;
          }
        }
      }

      .con {
        box-shadow: 5px 5px 5px #888888;
        border: 1px solid #cccccc;
        border-top: 0;
        padding-bottom: 12px;
        min-height: 400px;

        .con1 {
          .qr-code {
            padding: 60px 0 80px 0;

            img {
              display: block;
              margin: 0 auto;
            }
          }

          .tip {
            color: red;
            text-align: center;
            font-size: 16px;

            > p {
              &:nth-of-type(1) {
                font-size: 18px;
              }

              span {
                cursor: pointer;
                color: blue;
                text-decoration: underline;
              }
            }
          }
        }

        .con2 {
          padding-top: 15px;

          .con2-form {
            width: 500px;
            margin: 0 auto;

            .el-row {
              width: 100%;
            }

            .el-col-mobileCode {
              display: flex;
              align-items: center;
              justify-content: center;
              height: 100%;

              .el-button {
                background-color: #ffab30;
                border-color: #ffab30;
              }
            }

            .el-col-verifyCode {
              display: flex;
              align-items: center;
              justify-content: space-between;
              height: 100%;

              img {
                cursor: pointer;
              }

              .el-button {
                color: rgb(0, 0, 238);
              }
            }

            .el-form-item-f {
              :deep(.el-form-item__content) {
                display: flex;
                justify-content: center;

                .el-button {
                  background-color: #ab812d;
                  border-color: #ab812d;
                  height: 30px;
                  padding: 0 28px;
                  margin: 0 15px;

                  &:nth-of-type(1) {
                    background-color: #d1ab62;
                    border-color: #d1ab62;
                  }
                }
              }
            }
          }
        }
      }
    }
  }

  .content-tip {
    height: 50px;
    text-align: center;

    p {
      font-size: 16px;

      span {
        color: red;
        text-decoration: underline;
        cursor: pointer;
      }
    }
  }

  .inspection-footer {
    border-top: 1px solid #d5d5d5;
    width: 100%;
    background-color: rgb(189, 26, 45);
    padding-bottom: 12px;

    .con {
      width: 937px;
      margin: 0px auto;
      text-align: center;
      display: flex;
      justify-content: space-between;
      align-items: flex-start;

      .con1 {
        margin-top: 32px;
        display: flex;
        cursor: pointer;
        align-items: center;

        img {
          flex: 0 0 auto;

          &:nth-of-type(1) {
            margin: 5px;
          }
        }
      }

      .con2 {
        font-size: 12px;
        padding: 20px 20px 0 20px;

        .link {
          display: flex;
          align-items: center;
          justify-content: center;

          span {
            cursor: pointer;
            margin: 0 3px;
          }
        }

        .text {
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 0px 18px;
        }

        .tip {
          font-weight: bold;
        }
      }

      .con3 {
        margin-top: 20px;
        margin-right: 15px;
        display: flex;
        align-items: center;

        > li {
          &:not(:nth-of-type(1)) {
            margin-left: 4px;
          }

          img {
            width: 90px;
            height: 85px;
          }
        }
      }
    }
  }
}
</style>
